/*eslint-disable*/
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: '',
  message: '',
  code: '',
  created: '',
  updated: '',
  overlayMessage: null
}

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.message = action.payload.message
      state.id = action.payload.id
      state.code = action.payload.code
      state.created = action.payload.created
      state.updated = action.payload.updated
    },
    setOverlayError: (state, action) => {
      state.overlayMessage = action.payload.message
    },
  },
})

export default errorSlice.reducer
// selectors
export const selectErrorObject = (state) => state.error
// eslint-disable-next-line max-len
export const selectOverlayErrorObject = (state) => ({ message: state.error.overlayMessage })
// export actions
export const { setError, setOverlayError } = errorSlice.actions
